/* import __COLOCATED_TEMPLATE__ from './media.hbs'; */
/**

## Billboard Media

The Billboard Media component is a contextual component for use within a [Billboard](/components/glass/sq-billboard.html).
See the [Billboard component docs](/components/glass/sq-billboard.html) for usage.

`Billboard` uses contextual components.

@param {String} type - 'image'. 'image' is default. Set by using either `billboard.image`
                        when used as a contextual component within the billboard component (previously accomodated svgs)
@param {String} src - *Only works with image type* the path of the image to display
@param {Boolean} fullBleed - *Only works with image type* Remove the padding from the image and allow it
                              to go to the edges of the container
@param {Boolean} overlap - *Only works with image type* Allow the image to overlap behind the text to the
                            left within the billboard. Fully covers the background of the billboard by default

Style dependencies at: `@square/glass-ui/addon/styles/@square/messaging/billboard`

*/

import Component from '@ember/component';
import { assert } from '@ember/debug';
const TYPE = {
  IMAGE: 'image'
};

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['billboard__media'],
  classNameBindings: ['overlap:billboard__media--image-overlap', 'fullBleed:billboard__media--image-full'],
  attributeBindings: ['type:data-test-billboard-media'],
  type: TYPE.IMAGE,
  src: null,
  fullBleed: false,
  overlap: false,
  /*
    a11y: image alt is "" because the image is decorative.
    See https://www.w3.org/WAI/tutorials/images/decorative/
    The billboard text content provide the necessary information.
  */
  altText: '',
  didRecieveAttrs(...args) {
    this._super(...args);
    assert('`src` is required when using image type for billboard media', this.get('type') === TYPE.IMAGE && !this.get('src'));
  }
});